import React, {Component} from 'react';

export class Loader extends Component {
    render() {
        return (
            <img
                style={{
                    height: this.props.size,
                    width: this.props.size  
                }}
                src="/assets/app/media/img/dog_loader.gif"
            />
        )
    }
}

Loader.defaultProps = {
    size: 100
}


  